import { SearchListResult } from '../components/search-list-result-item';
import { FilterAndSearch } from '../components/filter-and-search';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getLabelValue } from '@/utils/getLabelValue';
import { SortAttendees } from '@/components/sort-attendees';

export function AttendeeList() {
  const [searchKey, setSearchKey] = useState('');
  const [selectedStatus, setSelectedStatus] = useState<string | null>(null);
  const [debouncedSearchKey, setDebouncedSearchKey] = useState(searchKey);
  const [searchParams] = useSearchParams();

  const [sortBy, setSortBy] = useState<'firstName' | 'lastName' | 'companyName' | 'email'>('firstName');
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('asc');

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedSearchKey(searchKey), 500);
    return () => clearTimeout(timer);
  }, [searchKey]);

  useEffect(() => {
    const status = searchParams.get('status');
    if (status) {
      const validStatuses = ['arrived', 'exited', 'notArrived', 'onsite', 'cancelled'];
      if (validStatuses.includes(status)) {
        setSelectedStatus(status);
      }
    }
  }, [searchParams]);

  return (
    <div className="flex flex-col gap-4 p-4">
      <div className="space-y-2">
        <h4 className="font-medium text-md leading-none">{getLabelValue('AttendeeTitle')}</h4>
        <p className="text-sm text-muted-foreground">{getLabelValue('AttendeeDescription')}</p>
      </div>
      <FilterAndSearch searchKey={searchKey} setSearchKey={setSearchKey} selectedStatus={selectedStatus} setSelectedStatus={setSelectedStatus} />
      <SortAttendees sortBy={sortBy} setSortBy={setSortBy} sortDirection={sortDirection} setSortDirection={setSortDirection} isMobile={true} />
      <SearchListResult searchKey={debouncedSearchKey} selectedStatus={selectedStatus} sortBy={sortBy} sortDirection={sortDirection} />
    </div>
  );
}
